module.exports = __webpack_public_path__ + "img/ai_IP_icon.50e6271d.png";